export enum MessageBoxType {
    Info,
    Warning,
    Alert
}
